<script setup lang="ts">
import { p__ } from '@@/bits/intl'
import OzBadge, { OzBadgeColorScheme, OzBadgeSizePreset } from '@@/library/v4/components/OzBadge.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'

withDefaults(
  defineProps<{
    text?: string
    icon?: string
    xIsLastUsedBadge?: boolean
  }>(),
  {
    text: '',
    icon: '',
    xIsLastUsedBadge: false,
  },
)

defineEmits(['click'])
</script>

<template>
  <OzContainedButton
    class="relative"
    :color-scheme="OzContainedButtonColorScheme.AlternativeHeavy"
    :text="text"
    :center-text="true"
    @click="$emit('click')"
  >
    <template #leftIcon>
      <OzIcon :name="icon" />
    </template>
    <OzBadge
      v-if="xIsLastUsedBadge"
      class="absolute -top-1 end-4"
      :text="p__('Text shown as a badge above the most recently used login method', 'Last used')"
      :size-preset="OzBadgeSizePreset.Default"
      :color-scheme="OzBadgeColorScheme.SelectionInverse"
    />
  </OzContainedButton>
</template>
